import React from 'react'
import Wrapper from '../helpers/Wrapper'
import serverImage from '../assets/images/server_down.svg'

function Maintenace() {
    return (
        <Wrapper>
            <div className='w-full relative h-[calc(100vh-50px)] flex justify-center items-center'>
                <div className='w-full space-y-2 text-center'>
                    <h1 className="text-[clamp(2.2rem,2vw+1rem,3rem)] font-medium font-serif text-center">
                        We'll Be Back Soon
                    </h1>
                    <p
                        className='text-[clamp(1rem,2vw+1rem,1.02rem)] text-gray-500 leading-6 font-serif'
                    >
                        We're Currently Under Maintenance <br />
                        Please check back later. We apologize for the inconvenience.
                    </p>

                    <div className="text-gray-600 flex items-center justify-center">
                        <img src={serverImage} alt="" />
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

export default Maintenace